/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { RefObject } from 'preact';

export default (formRef: RefObject<HTMLFormElement>): Record<string, any> => {
  if (!formRef.current) {
    return {};
  }

  const elements = formRef.current.elements;

  const formValues = Array.from(elements).reduce(
    (acc: Record<string, any>, el: any) => {
      if (el.name) {
        acc[el.name] = el.type === 'checkbox' ? el.checked : el.value;
      }
      return acc;
    },
    {}
  );

  return formValues;
};
